import { useIntl } from "react-intl";

export const useI18n = () => {
  const formatters = useIntl();
  const intlEnum = (name: string, value?: string | undefined | null) => {
    if (value === undefined || value === null) {
      return null;
    }
    const parsedValue = value.toLowerCase().replace(/[^a-z0-9_]/g, "");
    return formatters.formatMessage({ id: `enums.${name}.${parsedValue}` });
  };

  return {
    intlEnum,
  };
};
